import React, { useEffect, useRef } from 'react';
import { useVisitor } from '../context/VisitorContext';
import { useLang } from '../context/LangContext';
import { FaTimes } from 'react-icons/fa';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function GoogleLoginModal() {
  const { visitor, showLogin, loginWithGoogle, dismissLogin } = useVisitor();
  const { t } = useLang();
  const btnRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (!showLogin || visitor || !GOOGLE_CLIENT_ID) return;
    if (initialized.current) return;

    const initGoogle = () => {
      if (!window.google?.accounts?.id) return;
      initialized.current = true;

      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: (response) => {
          loginWithGoogle(response.credential);
        },
      });

      if (btnRef.current) {
        window.google.accounts.id.renderButton(btnRef.current, {
          type: 'standard',
          theme: 'outline',
          size: 'large',
          text: 'signin_with',
          width: 300,
          logo_alignment: 'center',
        });
      }
    };

    // Google script may load async
    if (window.google?.accounts?.id) {
      initGoogle();
    } else {
      const timer = setInterval(() => {
        if (window.google?.accounts?.id) {
          clearInterval(timer);
          initGoogle();
        }
      }, 200);
      return () => clearInterval(timer);
    }
  }, [showLogin, visitor, loginWithGoogle]);

  // Reset initialized when modal closes so it re-renders next time
  useEffect(() => {
    if (!showLogin) initialized.current = false;
  }, [showLogin]);

  if (!showLogin || visitor || !GOOGLE_CLIENT_ID) return null;

  return (
    <div className="glogin-overlay" onClick={dismissLogin}>
      <div className="glogin-modal" onClick={e => e.stopPropagation()}>
        <button className="glogin-close" onClick={dismissLogin}>
          <FaTimes />
        </button>
        <div className="glogin-header">
          <img src="/logo.svg" alt="GGLANCC" className="glogin-logo" />
          <h3>{t('loginTitle')}</h3>
          <p>{t('loginDesc')}</p>
        </div>
        <div className="glogin-btn-wrap" ref={btnRef} />
        <p className="glogin-skip" onClick={dismissLogin}>{t('loginSkip')}</p>
      </div>
    </div>
  );
}

export default GoogleLoginModal;
